export default __webpack_public_path__ + "static/media/Screenshot (1130).4105cdf6.png";